exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".img_upload_cbc28b3{width:120px;height:120px;border:1px solid #f0f2f8;border:solid 1px var(--color-border);border-radius:4px;background:#f6f8fa;background:var(--color-bg);color:#c8c8c8;display:flex;justify-content:center;align-items:center;cursor:pointer;float:left}.inline_block_c7cb45c{display:inline-block}.upload_file_76c76cc{width:0;height:0;visibility:hidden;opacity:0}.upload_file_label_c265754{cursor:pointer;display:inline-block;z-index:1;position:relative}", ""]);

// exports
exports.locals = {
	"img_upload": "img_upload_cbc28b3",
	"inline_block": "inline_block_c7cb45c",
	"upload_file": "upload_file_76c76cc",
	"upload_file_label": "upload_file_label_c265754"
};